module.exports = __webpack_public_path__ + "assets/retina_CDoubleSegDetailed.0d01031c07de341d5266908200651f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CDoubleSegDetailed.png
// module id = 626
// module chunks = 0